import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, useSearchParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../components/imports'

import { APP_NAME, PHOTOS_ROOT, WEBROOT } from '../constants/general'

import { Context } from '../class/Context'

import Func from '../class/Func'

import Paiements_Class from '../class/Paiements_Class'

import Annonces from '../class/Annonces'
import User from '../class/User';

function CommanderLot() {

    const navigate = useNavigate();

    const context = useContext(Context)

    const [flash, setFlash] = useState({})

    const [lot, setLot] = useState(false)

    const [annonces, setAnnonces] = useState(false)

    const [pointsRelais, setPointsRelais] = useState(false)

    const [typeLiv, setTypeLiv] = useState("dom")

    const [prix, setPrix] = useState(0)

    const [cartes, setCartes] = useState(false)

    const [get_params] = useSearchParams()

    const [infos, setInfos] = useState(false)

    const [nbrAchat, setNbrAchat] = useState(1)

    const [livraisonPrix, setLivraisonPrix] = useState('0.00')

    const [livraison, setLivraison] = useState('0.00')
    const [livraisonPr, setLivraisonPr] = useState('0.00')

    const [valide, setValide] = useState(false)

    const myInfos = async () => {

        let results = await User.session(true)

        if (results.success) {

            setInfos(results.data)

        }

    }

    const getCartes = async () => {

        let results = await Paiements_Class.user_cards()

        if (results.success) {

            if (results.data) {

                setCartes(results.data)

            } else {

                setCartes(results.message)

            }

        }

    }

    const getAnnonces = async (lot) => {

        let results = await Annonces.annoncesByLot(lot)

        if (results.success) {

            setAnnonces(results.data)

            setPrix(results.prix)

            setNbrAchat(results.nbr_achat)

            setLivraisonPrix(results.prix_livraison)

            setLivraison(results.prix_livraison)
            setLivraisonPr(results.prix_livraison_pr)

            setValide(true)

        } else {

            alert(results.message)

            navigate('/')

        }

    }

    const payer = async (e) => {

        e.preventDefault()

        let inputs = e.target

        if (inputs.use_card == undefined) {

            setFlash({ message: "Tu dois ajouter une carte de paiement", type: "error" })

            return false

        }

        if (typeLiv == 'relais' && inputs.point_retrait == undefined && inputs.point_retrait.value == undefined) {

            setFlash({ message: "Tu dois choisir un poit relais pour la livraison", type: "error" })

            return false

        }

        if (inputs.use_card.value !== "" && inputs.livraison.value !== "" && valide && livraison > 0 && annonces && lot) {

            let points_relais = (typeLiv == 'relais') ? inputs.point_retrait.value : 0

            setValide(false)

            let results = await Annonces.payerLot(inputs.use_card.value, lot, inputs.livraison.value, points_relais)

            setValide(true)

            if (results.success) {

                navigate('/mon-profile/discussion/' + results.discussion_id)

                setFlash({ message: "Pay", type: "succes" })

            } else {

                setFlash({ message: results.message, type: "error" })

            }

        } else {

            setFlash({ message: "Veuillez ajouter selectionner votre moyen de paiement pour continuer", type: "error" })

        }

    }

    const changeLivraisonType = async (prix, type) => {

        setLivraisonPrix(prix)

        setTypeLiv('dom')

        if (type == 'relais') {

            setTypeLiv('relais')

            let results = await Annonces.getPointsRelais('mondial_relay')

            if (results.code == 200 && results.pointsrelais.length > 0) {

                console.log(results.pointsrelais)
                setPointsRelais(results.pointsrelais)

            } else {

                setPointsRelais("Aucun point relais trouvé, veuillez vérifier votre adresse.")

            }

        }

    }

    useEffect(() => {

        let lot = get_params.get("lot")

        if (lot == null) lot = false

        setLot(lot)

        Func.session(context, navigate, '/connexion', true)

        Func.getFlash(setFlash)

        myInfos()

        getAnnonces(lot)

        getCartes()

        document.title = "Commander un lot - " + APP_NAME

        window.scrollTo(0, 0)

    }, [])

    return (

        <div>

            <Header />

            <div className="profil">

                <HeaderBox />

                <form method='POST' onSubmit={(e) => payer(e)} className='c content flex ai-start'>

                    <div className="col-7 pos-r">

                        <div className="paiements m_p10 m_mt_20">

                            <div className="bg6 p20 br10 mb20">

                                <h2 className='fw5 mb30 d-block'>Détails de la commande</h2>

                                {

                                    annonces

                                        ?

                                        annonces.map(annonce =>

                                            <div className='flex m_flex ai-center' key={annonce.idA}>

                                                <div className="flex m_flex ai-center mb20">
                                                    <img src={PHOTOS_ROOT + 'small/' + annonce.photos[0].name + '.jpg'} className='br10 mr20 w_h_60' style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                                    <div>
                                                        <p>{annonce.titre} <span className="h bg3 opt">{annonce.taille}</span></p>
                                                        {/* <p className='mb5 fz08'>Poids : { annonce.poids_colis }g</p> */}
                                                    </div>
                                                </div>

                                                <p className='fz12 fw7 mb30 m_col_3 ta-end'>{annonce.prix} €</p>

                                            </div>

                                        )

                                        :

                                        <div className='flex jc-center mt50 mb50'>
                                            <div className="lds-dual-ring col"></div>
                                        </div>

                                }

                            </div>

                            <div className="bg6 p20 br10 mb20">
                                <h2 className='fw5 mb30 d-block'>Adresse de livraison</h2>

                                {

                                    infos

                                        ?

                                        <div>
                                            <div>
                                                <span className='d-block mb5'>{infos.name}</span>

                                                {

                                                    infos.ville

                                                        ?

                                                        <>
                                                            <span className='d-block mb10'>{infos.rue}, {infos.ville}</span>
                                                            <span className='d-block fw7'>{infos.postal} {infos.ville}</span>
                                                        </>

                                                        :

                                                        <p className='fz09 error'>Adresse manquante</p>

                                                }

                                            </div>

                                            {

                                                infos.ville

                                                    ?

                                                    <Link to={'/mon-profile/parametres#parametres'} className='btn bg4 cl5 mt20'>Modifier</Link>


                                                    :

                                                    <Link to={'/mon-profile/parametres#parametres'} className='btn bg4 cl5 mt20'>Ajouter</Link>

                                            }

                                        </div>

                                        :

                                        <div className='mt50 mb50'>
                                            <div className="lds-dual-ring col"></div>
                                        </div>

                                }

                            </div>

                            <div className="bg6 p20 br10 mb20">
                                <h2 className='fw5 mb20 d-block'>Livraison</h2>

                                <img src={WEBROOT + "image/mondial_relay.webp"} className="col-2 m_col_4 mb10" />

                                {

                                    annonces

                                        ?

                                        <>
                                            <label className='d-block mb10'>
                                                <input type="radio" name='livraison' className='mr10' value="domicile" defaultChecked={true} onChange={e => changeLivraisonType(livraison, 'dom')}/>
                                                Domicile <strong>{livraison} €</strong>
                                            </label>

                                            <label>
                                                <input type="radio" name='livraison' className='mr10' value="point-relais" onChange={e => changeLivraisonType(livraisonPr, 'relais')} />
                                                Point relais <strong>{livraisonPr} €</strong>
                                            </label>

                                            {

                                                typeLiv == 'relais'

                                                    ?

                                                    pointsRelais

                                                        ?

                                                        typeof pointsRelais == "string"

                                                            ?

                                                            <p className='fz09'>{pointsRelais}</p>

                                                            :

                                                            <>

                                                                <h2 className='fw5 mb20 d-block mt40'>Points de retrait disponibles {pointsRelais.length}</h2>

                                                                {

                                                                    pointsRelais.map(pr =>

                                                                        <div className='mb10' key={pr.Num}>
                                                                            <label className='flex jc-start'>

                                                                                <input type="radio" name='point_retrait' value={pr.Num} className='mr10' required />

                                                                                <div>
                                                                                    <p className='fw5'>{pr.LgAdr1} ({pr.Distance / 1000} Km) <Link to={pr.URL_Plan} target='_blank' className='cl3 fz09 icon'>i</Link></p>
                                                                                    <span className='fz08 d-block '>{pr.CP} {pr.Ville}</span>
                                                                                    {pr.LgAdr3 != "" && <span className='fz08 d-block'>{pr.LgAdr3}</span>}
                                                                                </div>

                                                                            </label>

                                                                        </div>

                                                                    )

                                                                }

                                                            </>

                                                        :

                                                        <div className='mt50 mb50'>
                                                            <div className="lds-dual-ring col"></div>
                                                        </div>

                                                    :

                                                    <></>

                                            }

                                        </>

                                        :

                                        <div className='mt20 mb20'>
                                            <div className="lds-dual-ring col"></div>
                                        </div>

                                }


                            </div>

                            <div className="bg6 p20 br10 mb20">

                                <h2 className='fw5 mb30 d-block'>Options de paiement</h2>

                                <div>

                                    {

                                        cartes

                                            ?

                                            cartes.map(carte =>

                                                carte.Active

                                                &&

                                                <label className="flex ai-center jc-start mb20 m_flex" key={carte.Id}>

                                                    <input type="radio" className='mr20' name='use_card' value={carte.Id} required={true} />

                                                    <div>
                                                        <span className='d-block'>Carte {carte.CardProvider} : {carte.Alias}</span>
                                                        {/* <span>Expiration { carte.ExpirationDate.substring(0,2) + '/20' + carte.ExpirationDate.substring(2,4) }</span> */}
                                                    </div>

                                                </label>

                                            )

                                            :

                                            <div className='mt50 mb50'>
                                                <div className="lds-dual-ring col"></div>
                                            </div>

                                    }

                                    <div>
                                        <Link to={'/mon-profile/paiements/ajouter_carte'} className='mt10 btn bg4 cl1'>Ajouter</Link>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className='col-3 m_p10'>

                        <div className='ml20 bg7 br10 p20 m_ml_0'>

                            <h3 className='mb30'>Résumé de la commande</h3>

                            {

                                prix

                                    ?

                                    <div className='fz08'>

                                        <div className='flex mb5 m_flex'>
                                            <strong>Commande</strong>
                                            <p>{prix} €</p>
                                        </div>

                                        <div className='flex mb5 m_flex'>
                                            <strong>Frais de service</strong>
                                            <p>{((parseFloat(prix) * 0.05) + 0.98).toFixed(2)} €</p>
                                        </div>

                                        <div className='flex mb5 m_flex'>
                                            <strong>Frais de port</strong>
                                            <p>{livraisonPrix} €</p>
                                        </div>

                                        <div className='flex mb5 m_flex'>
                                            <strong>Total</strong>
                                            <strong>{(parseFloat(prix) + parseFloat(livraisonPrix) + (parseFloat(prix) * 0.05) + 0.98).toFixed(2)} €</strong>
                                        </div>

                                        {

                                            nbrAchat == 0

                                            &&

                                            <div className='flex m_flex mb5 jc-start mt20'>
                                                <input type='checkbox' name='cgu' className='mr5' required={true} />
                                                <p className='fw5 fz09'>J'accepte les <Link to={'https://www.laposte.fr/conditions-generales-de-vente'} target='_blank' className='cl4'>CGV</Link>, <Link to={'https://www.laposte.fr/conditions-contractuelles'} target='_blank' className='cl4'>CSV</Link>, <Link to={'https://sistersgreen.fr/image/autres/CPV_Colissimo_Courrier_Sisters_Green.pdf'} target='_blank' className='cl4'>CPV</Link> Colissimo et Courrier, <Link to={'https://www.mondialrelay.fr/envoi-de-colis/conditions-generales-de-vente/'} className='cl4' target='_blank'>CGV</Link>, <Link to={'https://www.mondialrelay.fr/media/125280/site-application-france-conditions-generales-dutilisation-fr-version-m%C3%A0j-14112024.pdf'} className='cl4' target='_blank'>CGU</Link> Mondial Relay</p>
                                            </div>

                                        }

                                    </div>

                                    :

                                    <div className='flex jc-center mt50 mb50'>
                                        <div className="lds-dual-ring col"></div>
                                    </div>

                            }

                            {flash !== '' && <p className={flash.type + " fz08 mb0"}>{flash.message}</p>}

                            {

                                valide

                                    ?

                                    <input type="submit" className='btn bg4 col-10 cl1 ta-center mt20 brc1solid brc4' value="Payer" />

                                    :

                                    <div className='flex jc-center mt10 mb30'>
                                        <div className="lds-dual-ring"></div>
                                    </div>

                            }

                            <p className='fz07 d-block ta-center mt5'>Paiement crypté et sécurisé</p>

                            <div className='flex m_flex jc-center mt10'>
                                <img src="/image/powered-by-stripe.svg" className='col-4 m_col_25' />
                            </div>

                        </div>

                    </div>

                </form>

            </div>

            <Footer />

        </div>

    )

}

export default CommanderLot